import styled from 'styled-components'
import { Theme, PageMain } from 'styles/index'

export const Container = styled(PageMain)<{ isExpanded: boolean }>`
  padding-top: 0px;
  padding-left: 0px;
  padding-bottom: 0px;
  .captacao-subtitle {
    margin-bottom: 20px;
    height: 17px;
    color: #868686;
    font-family: ${Theme.fontFamily.PRIMARY};
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.14px;
  }
  .captacao-title {
    height: 23px;
    margin-bottom: 48px;
    color: #000;
    font-family: ${Theme.fontFamily.PRIMARY};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .container-kanban {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    height: 100%;
  }
  .captacao-left-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .captacao-right-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    transition: all 1s;
    height: fit-content;
    width: ${({ isExpanded }) =>
      isExpanded ? 'calc(100% - 252px)' : 'calc(100% - 48px)'};
  }
  .captacao-toggle-container {
    width: 256px;
  }
`
